import React from "react"
import { Form, Message } from "semantic-ui-react"

const BifrostModalCreateItem = ({ showErrorMessage, errorMessage, children }) => {
	return (
		<>
			<>
				{showErrorMessage && <Message negative>{errorMessage ? <p>{errorMessage}</p> : <p>Something unexpected happened</p>}</Message>}
				<Form>{children}</Form>
			</>
		</>
	)
}

export default BifrostModalCreateItem
